/**
 * 배포 버전 표기 (#97) — `{날짜 태그}:sha-{커밋 7자}`.
 * 값은 CI 이미지 빌드가 발행 태그를 계산한 그 값을 `deploy/Dockerfile.web`의 build-arg로 넘겨
 * 번들에 넣습니다. 주입되지 않은 빌드(로컬·테스트)는 `dev`입니다 — 발행본과 헷갈리지 않게.
 */
export function buildVersionLabel(version: string | undefined, commit: string | undefined): string {
  const v = version?.trim();
  const c = commit?.trim();
  if (!v || !c) return "dev";
  return `${v}:sha-${c.slice(0, 7)}`;
}

export const buildVersion = buildVersionLabel(import.meta.env.VITE_BUILD_VERSION, import.meta.env.VITE_BUILD_COMMIT);
